export default {
  appName: "Antipartido",
  notificationText: "Install Antipartido",
  buttonText: "Install",
  installQuestion: "Install Antipartido on your phone?",
  tapToInstall: "Install",
  incompatibleBrowserTitle: "Your browser is not compatible",
  incompatibleBrowserMessage: "Open this link in Safari or Chrome to install the app.",
  incompatibleBrowserCopyLink: "Copy link",
  incompatibleBrowserLinkCopied: "Link copied!",
  iosStep1: "Tap <shareButton /> in the browser toolbar (on Safari inside <moreButton />)",
  iosStep2: "Scroll down and tap <addToHomeScreen />",
  shareText: "Share",
  moreText: "More",
  addToHomeScreenText: "Add to Home Screen",
  iosStep3: "If you don't see it, tap \"Show More\" at the bottom of the menu",
}
